import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
    CmpsButtonModule,
    CmpsIconModule,
    CmpsIconRegistry,
} from '@cmps/ng-uikit';
import { mdiAccountSearch } from '@mdi/js';

import { CmpsUserProfileComponent } from './user-profile.component';

@NgModule({
    declarations: [CmpsUserProfileComponent],
    imports: [CommonModule, CmpsIconModule, CmpsButtonModule],
    exports: [CmpsUserProfileComponent],
})
export class CmpsUserProfileModule {
    constructor(
        private readonly _domSanitizer: DomSanitizer,
        private readonly _iconRegistry: CmpsIconRegistry,
    ) {
        [['search', mdiAccountSearch]].forEach(([name, icon]) => {
            _iconRegistry.addSvgIconFromHtml(
                name,
                _domSanitizer.bypassSecurityTrustHtml(
                    `<svg id="${name}"><path d="${icon}"></path></svg>`,
                ),
                '__internal',
            );
        });
    }
}
